import { UIKitIcon } from '../icon';

export const downloadIcon: UIKitIcon = {
  name: 'download',
  // eslint-disable-next-line max-len
  data: '<svg width="33" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27.868 22.14v3.907c0 .346-.133.677-.37.921a1.244 1.244 0 0 1-.893.381H6.395c-.335 0-.657-.137-.893-.38a1.323 1.323 0 0 1-.37-.922v-3.906M16.715 4v18.14"/><path d="m23.738 15.484-7.023 7.085-7.023-7.085"/></svg>',
};
